/* eslint-disable */
export default {
  searchTerm: state => state.searchTerm,
};
